import script from "./TagPill.vue?vue&type=script&setup=true&lang=js"
export * from "./TagPill.vue?vue&type=script&setup=true&lang=js"

import "./TagPill.vue?vue&type=style&index=0&id=533008c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-533008c8"]])

export default __exports__